const parse = (value: unknown): Date | null => {
    if (typeof value !== 'string' || value === '') return null
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? null : date
}

/** `24.04.2026` або null */
export const formatDate = (value: unknown): string | null => {
    const date = parse(value)
    return date ? date.toLocaleDateString('uk-UA', { day: '2-digit', month: '2-digit', year: 'numeric' }) : null
}

/** `24.04.2026, 11:00` або null */
export const formatDateTime = (value: unknown): string | null => {
    const date = parse(value)
    return date
        ? date.toLocaleString('uk-UA', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
          })
        : null
}
